import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label: "Projeto" },
    { value: 2, label: "Projeto/Execução" },
];

const ArtCivil = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { ArtCivil, options as OpcoesArtCivil }